<script>
    import z from 'zxcvbn'

    export let model_root;
    export let hash;

    let errorMsg = "";
    let successMsg = "";

    let name = "";
    let prename = "";
    let password = "";
    let password_repeat = "";

    $: s = z(password).score > 3

    let hash_valid = fetch(model_root + 'admin/user_management/is_hash_valid.php?r='+hash, {
            method: "GET"
        })
            .then(response => response.text());

    function registerUser() {
        const data = new FormData();
        data.append("hash", hash);
        data.append("name", name);
        data.append("prename", prename);
        data.append("password", password);
        data.append("password_repeat", password_repeat);

        fetch(model_root + 'admin/user_management/register_user.php', {
            method: "POST",
            body: data
        })
            .then(response => response.text())
            .then(msg => {
                if(msg === "success") {
                    showSuccessMsg("Die Registrierung wurde erfolgreich abgeschlossen! Sie werden automatisch weitergeleitet.");
                } else {
                    showErrorMsg(msg);
                }
            });

    }

    function showSuccessMsg(msg) {
        errorMsg = "";
        successMsg = msg;
        setTimeout(() => {
            window.open("/", "_self");
        }, 1800);
    }

    function showErrorMsg(msg) {
        errorMsg = msg;
    }

</script>

<div class="row border-bottom pb-3 mb-3">
    <div class="col-12">
        <a href="https://www.maleck.org" target="_blank">
            <img src="https://www.maleck.org/us/img/logo_v3_test.png" class="w-100 mb-3 maleck_logo">
        </a>
    </div>
    <div class="col">
        <h4 class="header-maleck">Herzlich Willkommen bei <b>FujanaCMS</b>!</h4>
    </div>
</div>

{#await hash_valid}
    <p class="text-center mt-4 mb-4"><i class="fas fa-circle-notch fa-spin"></i> Bitte warten Sie einen Moment...</p>
{:then response}
    {#if response === "valid"}

        <form class="mb-1"
              on:submit|preventDefault={ () => registerUser() }>

            <p>Bitte geben Sie Ihren Namen ein und wählen Sie ein sicheres Passwort für Ihren Account: </p>

            <div class="row">
                <div class="col">
                    <label class="mr-sm-2" for="prename">Vorname:</label>
                    <input type="text" class="form-control" id="prename" placeholder="Vorname" bind:value={prename}>
                </div>
                <div class="col">
                    <label class="mr-sm-2" for="name">Nachname:</label>
                    <input type="text" class="form-control" id="name" placeholder="Nachname" bind:value={name}>
                </div>
            </div>
            <div class="row">
                <label class="mr-sm-2" for="password">Passwort:</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fas fa-key"></i>&#8205;</span>
                    </div>
                    <input type="password" class="form-control" placeholder="Passwort" id="password" bind:value={password}>
                </div>
            </div>
            <div class="row">
                <label class="mr-sm-2" for="password_repeat">Passwort wiederholen:</label>
                <div class="input-group mb-2">
                    <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fas fa-key"></i>&#8205;</span>
                    </div>
                    <input type="password" class="form-control" placeholder="Passwort wiederholen" id="password_repeat" bind:value={password_repeat}>
                </div>
            </div>
            {#if password.length > 0}
                <div class="alert alert-light border mb-3 py-2 px-2 text-success" style={s||'color:#af4154 !important'}>
                    <i class="fas fa-info-circle me-1"></i> {s ? 'Starkes' : 'Schwaches'} Passwort
                </div>
            {/if}

            {#if errorMsg.length > 0}
                <div class="alert alert-danger" role="alert">
                    {errorMsg}
                </div>
            {/if}
            {#if successMsg.length > 0}
                <div class="alert alert-success" role="alert">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    {successMsg}
                </div>
            {/if}

            <button class="btn btn-primary btn-maleck mt-1" type="submit" disabled={!s}>
                <i class="fas fa-sign-in-alt"></i> Account anlegen
            </button>
        </form>

    {:else}
        <div class="alert alert-danger" role="alert">
            {response}
        </div>
    {/if}
{:catch error}
    <div class="alert alert-danger" role="alert">
        Ein Fehler ist aufgetreten!
    </div>
{/await}


<style>

    .maleck_logo {
        max-width: 140px;
    }

    .header-maleck {
        color: #2f3e51;
    }

    .btn-maleck {
        background: #2f3e51;
        border-color: #2f3e51;
    }

</style>
